<mat-tree
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  class="tree"
>
  <!-- Nó simples -->
  <mat-tree-node
    *matTreeNodeDef="let node"
    matTreeNodeToggle
    (click)="handleNodeClick(node)"
    [showIfPermission]="node.permissions"
  >
    <li class="mat-tree-node">
      <a
        class="estricta uppercase bolder"
        [attr.data-cy]="returnDataCy(node.name)"
        (click)="handleNodeClick(node)"
      >
        {{ node.name }}
      </a>
    </li>
  </mat-tree-node>

  <!-- Nó com filhos -->
  <mat-nested-tree-node
    *matTreeNodeDef="let node; when: hasChild"
  >
    <li
      matTreeNodeToggle
      class="mat-nested-tree-item"
      [showIfPermission]="node.permissions"
      [attr.data-cy]="returnDataCy(node.name)"
    >
      <!-- Cabeçalho do nó -->
      <div class="flex estricta uppercase bolder">
        <mat-icon class="icon-display">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
        <a>{{ node.name }}</a>
      </div>

      <!-- Subárvore -->
      <ul
        class="sub-tree"
        [@slideVertical]="treeControl.isExpanded(node) ? 'expanded' : 'collapsed'"
      >
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </mat-nested-tree-node>
</mat-tree>
